import { render, staticRenderFns } from "./edit-feecolumn.vue?vue&type=template&id=501b7a97&scoped=true"
import script from "./edit-feecolumn.vue?vue&type=script&lang=js"
export * from "./edit-feecolumn.vue?vue&type=script&lang=js"
import style0 from "./edit-feecolumn.vue?vue&type=style&index=0&id=501b7a97&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501b7a97",
  null
  
)

export default component.exports